var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 57.8226L90.6 46.7875L82.7433 55.2496L94 57.8226ZM24.5 58.3901L25.2415 59.0611C41.4468 41.1543 69.5465 39.873 86.8162 52.508L87.4067 51.701L87.9971 50.8939C69.9438 37.6855 40.6864 39.014 23.7585 57.7191L24.5 58.3901Z",
    fill: "#CC0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7944 33.1122V21.8079C69.9216 20.1615 68.8022 17.993 68.8022 16.447C68.8022 14.9009 66.5127 15.0013 66.5127 15.0013H59.8475H58.8045H52.1393C52.1393 15.0013 49.8497 14.9009 49.8497 16.447C49.8497 17.993 48.7304 20.1615 48.8576 21.8079V33.0921C48.8576 33.0921 48.476 35.361 51.0708 35.361H58.779C59.415 35.361 59.8221 35.361 59.8221 35.361H67.5303C70.1505 35.361 69.7435 33.0921 69.7435 33.0921L69.7944 33.1122Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_7312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 35,
    width: 20,
    height: 58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9824 35.3208H49.6992V92.7253H68.9824V35.3208Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_7312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7644 29.6182H58.8994C54.6985 29.6182 51.293 32.3061 51.293 35.6217V85.2959C51.293 88.6116 54.6985 91.2994 58.8994 91.2994H59.7644C63.9653 91.2994 67.3708 88.6116 67.3708 85.2959V35.6217C67.3708 32.3061 63.9653 29.6182 59.7644 29.6182Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3389 18.1538V32.0682",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8418 19.8604V32.0681",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8057 19.8604V32.0681",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.578 43.375H54.8545V81.6203H66.578",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 55.3511V55.706H66.8011V55.3511H61.3643Z",
    fill: "#33333F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 54.9517V55.129H66.8011V54.9517H61.3643Z",
    fill: "#33333F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 54.3745V54.552H66.8011V54.3745H61.3643Z",
    fill: "#33333F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 53.4214V53.5989H66.8011V53.4214H61.3643Z",
    fill: "#33333F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 52.6665V52.844H66.8011V52.6665H61.3643Z",
    fill: "#33333F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 51.7134V52.0683H66.7658V51.7134H61.3291Z",
    fill: "#33333F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 51.292V51.4695H66.8011V51.2921L61.3643 51.292Z",
    fill: "#33333F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 50.1826V50.7372H66.7658V50.1826H61.3291Z",
    fill: "#33333F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 49.207V49.3845H66.8011V49.207H61.3643Z",
    fill: "#33333F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 49.6055V49.9604H66.8011V49.6055H61.3643Z",
    fill: "#33333F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 48.4521V49.0067H66.8011V48.4521H61.3643Z",
    fill: "#33333F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 47.499V47.854H66.8011V47.499H61.3643Z",
    fill: "#33333F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 47.0767V47.2541H66.8011V47.0767H61.3643Z",
    fill: "#33333F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 63.9873V64.3422H66.8011V63.9873H61.3643Z",
    fill: "#33333F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 63.5879V63.7654H66.8011V63.5879H61.3643Z",
    fill: "#33333F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 63.0112V63.1887H66.8011V63.0113L61.3643 63.0112Z",
    fill: "#33333F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 62.0571V62.2346H66.8011V62.0571H61.3643Z",
    fill: "#33333F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 61.3032V61.4807H66.8011V61.3032H61.3643Z",
    fill: "#33333F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 60.3491V60.7041H66.7658V60.3491H61.3291Z",
    fill: "#33333F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 59.9287V60.1062H66.8011V59.9287H61.3643Z",
    fill: "#33333F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 58.8193V59.3739H66.7658V58.8193H61.3291Z",
    fill: "#33333F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 57.8438V58.0212H66.8011V57.8438H61.3643Z",
    fill: "#33333F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 58.2422V58.5971H66.8011V58.2422H61.3643Z",
    fill: "#33333F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 57.0884V57.6429H66.8011V57.0884H61.3643Z",
    fill: "#33333F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 56.1353V56.4902H66.8011V56.1353H61.3643Z",
    fill: "#33333F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 55.7134V55.8908H66.8011V55.7134H61.3643Z",
    fill: "#33333F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 72.6235V72.9785H66.8011V72.6235H61.3643Z",
    fill: "#33333F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 72.2241V72.4016H66.8011V72.2241H61.3643Z",
    fill: "#33333F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 71.6475V71.8249H66.8011V71.6475H61.3643Z",
    fill: "#33333F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 70.6938V70.8713H66.8011V70.6939L61.3643 70.6938Z",
    fill: "#33333F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 69.939V70.1164H66.8011V69.939H61.3643Z",
    fill: "#33333F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 68.9858V69.3408H66.7658V68.9858H61.3291Z",
    fill: "#33333F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 68.5649V68.7424H66.8011V68.5649H61.3643Z",
    fill: "#33333F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 67.4556V68.0101H66.7658V67.4556H61.3291Z",
    fill: "#33333F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 66.4795V66.657H66.8011V66.4795H61.3643Z",
    fill: "#33333F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 66.8784V67.2333H66.8011V66.8784H61.3643Z",
    fill: "#33333F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 65.7246V66.2792H66.8011V65.7246H61.3643Z",
    fill: "#33333F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 64.7715V65.1264H66.8011V64.7715H61.3643Z",
    fill: "#33333F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3643 64.3496V64.527H66.8011V64.3496H61.3643Z",
    fill: "#33333F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 75.6704V76.0253H66.7658V75.6704H61.3291Z",
    fill: "#33333F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 75.2705V75.448H66.7658V75.2705H61.3291Z",
    fill: "#33333F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 74.6938V74.8713H66.7658V74.6938H61.3291Z",
    fill: "#33333F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 73.7402V73.9176H66.7658V73.7402H61.3291Z",
    fill: "#33333F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3291 72.9854V73.1628H66.7658V72.9854H61.3291Z",
    fill: "#33333F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1772 57.6083C58.1772 57.6083 58.2093 57.5578 58.2413 57.5578H58.7696C58.7696 57.5578 58.8336 57.583 58.8336 57.6083V59.1372C58.8336 59.1372 58.8016 59.2004 58.7536 59.2004C57.2327 59.1878 56.2881 58.6445 56.2881 57.5072C56.2881 56.4205 57.2327 55.7129 58.6575 55.7129C60.0824 55.7129 61.027 56.4585 61.027 57.583C61.027 58.1516 60.7868 58.5686 60.4026 58.8845C60.3705 58.9098 60.3386 58.8971 60.3226 58.8845L59.8102 58.556C59.8102 58.556 59.7942 58.5307 59.7942 58.5181C59.7942 58.5054 59.7942 58.4928 59.8102 58.4802C59.9863 58.3286 60.2425 57.9874 60.2425 57.5704C60.2425 56.8249 59.6181 56.332 58.6735 56.332C57.729 56.332 57.1046 56.7996 57.1046 57.5072C57.1046 58.0885 57.4728 58.4549 58.1932 58.556V57.5957L58.1772 57.6083Z",
    fill: "#9E8959"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M61.027 61.4619C61.027 62.5865 60.0824 63.3194 58.6575 63.3194C57.2327 63.3194 56.2881 62.5865 56.2881 61.4619C56.2881 60.3373 57.2327 59.5918 58.6575 59.5918C60.0824 59.5918 61.027 60.3373 61.027 61.4619ZM57.0886 61.4619C57.0886 62.1947 57.7129 62.7002 58.6575 62.7002C59.6021 62.7002 60.2265 62.2074 60.2265 61.4619C60.2265 60.7163 59.6021 60.2235 58.6575 60.2235C57.7129 60.2235 57.0886 60.7163 57.0886 61.4619Z",
    fill: "#9E8959"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.07 65.721C57.07 65.721 57.054 65.7715 57.006 65.7715H56.4137C56.4137 65.7715 56.3496 65.7463 56.3496 65.721V63.9647C56.3496 63.9647 56.3816 63.9141 56.4137 63.9141H60.8963C60.8963 63.9141 60.9604 63.9394 60.9604 63.9647V64.4954C60.9604 64.4954 60.9284 64.5459 60.8963 64.5459H57.07V65.721Z",
    fill: "#9E8959"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3496 66.3518C56.3496 66.3518 56.3816 66.3013 56.4137 66.3013H60.8963C60.8963 66.3013 60.9604 66.3265 60.9604 66.3518V67.4258C60.9604 68.5378 60.0639 69.2833 58.655 69.2833C57.2462 69.2833 56.3496 68.5378 56.3496 67.4258V66.3518ZM60.2239 66.9331H57.1181V67.4258C57.1181 68.1714 57.7265 68.6641 58.671 68.6641C59.6156 68.6641 60.2239 68.1714 60.2239 67.4258V66.9331Z",
    fill: "#9E8959"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1594 61.708L93.9112 61.0486L92.5923 59.5451L91.8406 60.2045L92.5 60.9562L93.1594 61.708ZM24 60.9562L29.8528 70.91L35.5466 60.8644L24 60.9562ZM92.5 60.9562L91.8406 60.2045C85.418 65.8382 75.5517 69.2313 64.7122 70.0402C53.8875 70.848 42.2116 69.0679 32.2499 64.4869L31.8321 65.3954L31.4143 66.3039C41.717 71.0418 53.7369 72.8648 64.861 72.0347C75.9703 71.2056 86.3058 67.7198 93.1594 61.708L92.5 60.9562Z",
    fill: "#CC0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical3);
export default __webpack_public_path__ + "static/media/clinical_3.17a8bb404e5b603e62b2fd9ecc46ff83.svg";
export { ForwardRef as ReactComponent };